import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=bff5adfc&scoped=true&"
import script from "./Scale.vue?vue&type=script&lang=js&"
export * from "./Scale.vue?vue&type=script&lang=js&"
import style0 from "./Scale.vue?vue&type=style&index=0&id=bff5adfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff5adfc",
  null
  
)

export default component.exports